export default "__VITE_ASSET__C$j3s53e__"